export const UserFeatureFlags = Object.freeze({
  designSystemAlpha: 'design_system_alpha',
  teams: 'teams',
  instantOffers: 'instantOffers',
  learning: 'learning',
  featureCasesRecovery: 'feature_cases_recovery',
  featureCasesCreditImprovement: 'feature_cases_credit_improvement',
  featureCasesRandd: 'feature_cases_randd',
  featureCasesGrants: 'feature_cases_grants',
  accountingConnections: 'accountingConnections',
  profilesAlpha: 'profiles_alpha',
  capitalReport: 'capitalReport',
  featureCreditScores: 'feature_credit_scores',
  featureCreditProfiles: 'feature_credit_profiles',
});

export const UserMembershipFeatures = Object.freeze({
  adviser: 'adviser',
  learningLicense: 'learning_license',
  productFunding: 'product_funding',
  dealDashboard: 'deal_dashboard',
  productMonitor: 'product_monitor',
  recovery: 'recovery',
  playbook: 'playbook',
  fundingReport: 'funding_report',
  featureWorkingCapital: 'feature_working_capital',
  xero: 'xero',
  featureLearnIsSequential: 'feature_learn_is_sequential',
  featureLearnMastery: 'feature_learn_mastery',
  integrationsWebsiteQuestionnaire: 'integrations_website_questionnaire',
  featureUserInvitations: 'feature_user_invitations',
  monitoring: 'monitoring',
  featureMeganav: 'feature_meganav',
  planFriendlyName: 'plan_friendly_name',
  creditReportDownloads: 'credit_report_downloads',
  capitalReport: 'feature_capital_report',
  clientLimitPurchase: 'client_limit_purchase',
});
